import SearchTableQuery from 'mini-mail-list-store/lib/store/schema/SearchTableQuery';
import { getListViewType } from 'owa-mail-store/lib/utils/getListViewType';
import { getMailSearchStore } from '../store/Store';
import { getSearchSessionId } from 'mini-3s-search-store/lib/selectors/getSearchSessionId';
import { getSearchValueForQuery } from 'mini-3s-search-store/lib/selectors/getCurrentQuery';
import { isSearchWithinFromFolder } from './isSearchWithinFromFolder';
import { SubstrateKqlPrefix } from 'mini-3s-service/lib/schema/SubstrateKqlPrefix';
import { TableQueryType } from 'mini-mail-list-store/lib/store/schema/TableQuery';

/**
 * Returns a SearchTableQuery from values in 3s search store
 */
export const createSearchTableQuery = () => {
    const { searchNumber, currentFolderScopeId } = getMailSearchStore();
    // TODO : WI #91214 : Long KQL string results in 3s throwing error. Check how can we reduce this.
    // Have removed to, cc, and bcc for now.
    const isFromFolder = isSearchWithinFromFolder(currentFolderScopeId);
    const currentQuery = getSearchValueForQuery(
        isFromFolder ? SubstrateKqlPrefix.FROM : SubstrateKqlPrefix.TO
    );

    const searchTableQuery = {
        folderId: null,
        listViewType: getListViewType(),
        type: TableQueryType.Search,
        searchNumber: searchNumber,
        queryString: currentQuery.QueryString,
        displayQueryString: currentQuery.DisplayQueryString,
        searchFolderScopeId: currentFolderScopeId,
        searchSessionGuid: getSearchSessionId(),
        rowOffset: 0,
    } as SearchTableQuery;

    return searchTableQuery;
};
